var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoal3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.2535 30.5816c0-3.3998-2.2467-6.1952-5.6555-6.1952-1.7043 0-3.7961 1.8132-4.8807 2.9465-1.0846-1.1333-3.0214-2.9465-4.7258-2.9465-3.4087 0-5.8103 2.7954-5.8103 6.1952 0 1.7377.6972 3.2487 1.7818 4.382l8.7543 8.5373 8.7543-8.5373c1.0846-1.1333 1.7819-2.6443 1.7819-4.382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0668 57.4023c-.7747-.0756-1.317-.5289-1.3945-1.1333l-4.4159-25.2341-6.74 12.1638c-.3099.5288-.9297.831-1.5495.6799-.6197-.0755-1.0846-.6044-1.162-1.2088l-2.8665-19.4922-5.1906 11.4082c-.2325.5289-.7747.8311-1.3171.8311H2.13309c-.77471 0-1.471957-.6044-1.471957-1.4355 0-.7555.619767-1.4354 1.471957-1.4354H21.5011l6.895-15.0347c.2324-.6044.8522-.9066 1.472-.8311.6197.0756 1.162.6044 1.2395 1.2088l2.9439 20.0966 6.6626-12.0126c.3099-.5289.8522-.8311 1.472-.68.6197.0756 1.0846.5289 1.162 1.1333l4.1061 23.3453L62.4063 1.26778c.1549-.528856.6972-.982165 1.2395-.982165.6198-.075551 1.1621.302204 1.3945.755515l7.9021 15.94127c.3099.68.0775 1.511-.6972 1.8888-.6972.3022-1.5494.0756-1.9368-.68L64.0332 5.49864 48.3838 56.269c-.1549.7555-.6972 1.1333-1.317 1.1333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal3);
export default __webpack_public_path__ + "static/media/goal-3.1ec9fa5927f63c9cd500581889cd8bb1.svg";
export { ForwardRef as ReactComponent };